const SELECTORS = {
  TOGGLE: '[data-description-toggle]',
  CONTAINER: '[data-description-container]',
  TRUNCATED: '[data-description-truncated]',
  FULL: '[data-description-full]',
};

const STATES = {
  EXPANDED: 'Read Less',
  COLLAPSED: 'Read More',
};

/**
 * Toggle the visibility of content sections
 * @param {HTMLElement} truncated - The truncated content element
 * @param {HTMLElement} full - The full content element
 * @param {boolean} isExpanded - Current expanded state
 */
const toggleContentVisibility = (truncated, full, isExpanded) => {
  truncated.classList.toggle('hidden', !isExpanded);
  full.classList.toggle('hidden', isExpanded);
};

/**
 * Handle click event on the "Read More" toggle buttons
 * @param {Event} event - Click event
 */
const handleToggleClick = event => {
  const button = event.currentTarget;
  const container = button.closest(SELECTORS.CONTAINER);
  const truncatedContent = container.querySelector(SELECTORS.TRUNCATED);
  const fullContent = container.querySelector(SELECTORS.FULL);
  const isExpanded = truncatedContent.classList.contains('hidden');

  toggleContentVisibility(truncatedContent, fullContent, isExpanded);
  button.textContent = isExpanded ? STATES.COLLAPSED : STATES.EXPANDED;
};

/**
 * Initialize "Read More" functionality for the "Read More" buttons
 * Handles the toggling between truncated and full descriptions
 */
export default function initReadMore() {
  const toggleButtons = document.querySelectorAll(SELECTORS.TOGGLE);

  if (!toggleButtons.length) return;

  toggleButtons.forEach(button => {
    button.addEventListener('click', handleToggleClick);
  });
}
